import { useState } from "react";
import BottomNav from "../components/BottomNav";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { transactionsApi } from "../services/api";
import { TransactionTypeSelect } from "../components/SelectField";
import toast from "react-hot-toast";

const T = { night:"#0A1F3D", royal:"#1263B0", cyan:"#1CBCD3", gold:"#C9922A",
  white:"#fff", bg:"#F7F9FC", border:"#E2E8F0" };

export default function CertifyTransaction() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);
  const [form, setForm] = useState({
    transactionType:"", description:"", declaredAmount:"",
    actDate: new Date().toISOString().split("T")[0],
    actLocation:"", partie2Phone:""
  });

  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const canSubmit = form.transactionType && form.description && form.partie2Phone && form.actDate;

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const r = await transactionsApi.initiate(form);
      setDone(r.data?.data);
      toast.success(t("certify.success_title"));
    } catch { toast.error(t("certify.error")); }
    finally { setLoading(false); }
  };

  if (done) return (
    <div style={{ minHeight:"100vh", background:T.bg, fontFamily:"'DM Sans',sans-serif",
      display:"flex", alignItems:"center", justifyContent:"center", padding:"24px 24px 80px" }}>
      <div style={{ background:T.white, borderRadius:"20px", padding:"40px",
        maxWidth:"480px", width:"100%", textAlign:"center", border:"1px solid #E2E8F0" }}>
        <div style={{ fontSize:"56px", marginBottom:"16px" }}>✅</div>
        <h2 style={{ color:T.night, fontSize:"20px", fontWeight:700, marginBottom:"8px" }}>
          {t("certify.success_title")}
        </h2>
        <p style={{ color:"#64748B", fontSize:"14px", lineHeight:1.6, marginBottom:"20px" }}>
          {t("certify.success_desc")}
        </p>
        <div style={{ background:"#F1F5F9", borderRadius:"10px", padding:"12px 16px",
          marginBottom:"24px", fontSize:"13px", color:"#334155" }}>
          <strong>{t("certify.reference")} :</strong> {done.reference}
        </div>
        <div style={{ background:"#FBF4E8", borderRadius:"10px", padding:"10px 16px",
          fontSize:"12px", color:"#A67820", marginBottom:"24px" }}>
          {t("certify.waiting")}
        </div>
        <button onClick={()=>nav("/dashboard")}
          style={{ width:"100%", padding:"14px", background:T.royal, color:T.white,
            border:"none", borderRadius:"12px", fontWeight:700, cursor:"pointer" }}>
          {t("certify.back")}
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background:T.bg, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ background:`linear-gradient(135deg,${T.cyan},#0E8FA3)`,
        padding:"20px 24px", display:"flex", alignItems:"center", gap:"16px" }}>
        <button onClick={()=>nav("/dashboard")}
          style={{ background:"transparent", border:"none", color:T.white, fontSize:"20px", cursor:"pointer" }}>←</button>
        <div>
          <h1 style={{ color:T.white, fontSize:"17px", fontWeight:700, margin:0 }}>{t("certify.title")}</h1>
          <p style={{ color:"rgba(255,255,255,0.7)", fontSize:"12px", margin:0 }}>{t("certify.subtitle")}</p>
        </div>
      </div>

      <div style={{ maxWidth:"600px", margin:"0 auto", padding:"24px 24px 80px" }}>
        <div style={{ background:"#E0F7FA", borderLeft:"4px solid #1CBCD3",
          padding:"12px 16px", borderRadius:"0 12px 12px 0",
          fontSize:"13px", color:"#0E8FA3", marginBottom:"20px" }}>
          {t("certify.info")}
        </div>

        <div style={{ marginBottom:"16px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
            marginBottom:"6px", display:"block" }}>{t("certify.type")} *</label>
          <TransactionTypeSelect value={form.transactionType} onChange={e=>set("transactionType",e.target.value)} />
        </div>

        <div style={{ marginBottom:"16px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
            marginBottom:"6px", display:"block" }}>{t("certify.description")} *</label>
          <textarea value={form.description} onChange={e=>set("description",e.target.value)}
            placeholder={t("certify.description_placeholder")}
            rows={4} spellCheck={false}
            style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
              borderRadius:"12px", fontSize:"14px", outline:"none",
              boxSizing:"border-box", resize:"none" }}/>
        </div>

        {[{label:t("certify.amount"),name:"declaredAmount",ph:t("certify.amount_placeholder"),type:"number"},
          {label:t("certify.location"),name:"actLocation",ph:t("certify.location_placeholder")},
          {label:t("certify.contact_phone"),name:"partie2Phone",ph:"+237 6XX XX XX XX",required:true}
        ].map(f => (
          <div key={f.name} style={{ marginBottom:"16px" }}>
            <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
              marginBottom:"6px", display:"block" }}>
              {f.label}{f.required?" *":""}
            </label>
            <input type={f.type||"text"} value={form[f.name]}
              onChange={e=>set(f.name,e.target.value)}
              placeholder={f.ph}
              style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
                borderRadius:"12px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}/>
            {f.name==="partie2Phone" && (
              <p style={{ fontSize:"11px", color:"#94A3B8", marginTop:"5px" }}>
                {t("certify.contact_note")}
              </p>
            )}
          </div>
        ))}

        <div style={{ marginBottom:"24px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
            marginBottom:"6px", display:"block" }}>{t("certify.date")} *</label>
          <input type="date" value={form.actDate} onChange={e=>set("actDate",e.target.value)}
            style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
              borderRadius:"12px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}/>
        </div>

        <button onClick={handleSubmit} disabled={!canSubmit||loading}
          style={{ width:"100%", padding:"16px",
            background:canSubmit&&!loading?T.cyan:"#E2E8F0",
            color:canSubmit&&!loading?T.white:"#94A3B8",
            border:"none", borderRadius:"12px", fontWeight:700,
            cursor:canSubmit&&!loading?"pointer":"not-allowed", fontSize:"15px" }}>
          {loading?t("common.loading"):t("certify.submit")}
        </button>
      </div>
      <BottomNav />
    </div>
  );
}
